export const ADDBOOKS = "books/addBooks";
export const LOADBOOKS = "books/loadBooks";
export const DELETEBOOK = "books/deleteBook";
export const EDITBOOK = "books/editBook";
